<template>
  <div class="payment" v-if="visible">
    <div class="payment-box">
      <div class="title">Secure Payment Initiated<i @click="handleClose"></i></div>
      <div class="recommend">
        <h3>Set up your credit or debit card</h3>
        <p>Debit card, Credit card, and Prepaid card are all supported</p>
        <div class="payment-display">
          <div class="item" v-for="item in 6" :key="item">
            <img :src="require(`@/assets/images/payment/payment-0${item}.png`)" alt="" />
          </div>
        </div>
      </div>
      <div class="fill">
        <div class="card">
          <input type="number" name="cardnumber" placeholder="Card Number" autocomplete="cc-number" pattern="[\d ]{10,30}" v-model="cardNumber"/>
          <input type="text" class="email" placeholder="Email" name="email" autocomplete="email" v-model="email" />
        </div>
        <div class="message">
          <input type="text" placeholder="MM/YY" name="cc-exp" autocomplete="cc-exp" v-model="date" @input="handleInput"/>
          <input type="number" placeholder="CVC/CVV" name="cvc" autocomplete="cc-csc" v-model="cvv"/>
        </div>
        <div class="address">
          <input type="text" placeholder="First Name" name="given-name" autocomplete="given-name" v-model="firstName" />
          <input type="text" placeholder="Last Name" name="family-name" autocomplete="family-name" v-model="lastName" />
        </div>
      </div>
      <div class="describe" v-if="payType === 'subscription'">
        <p>{{ productInfo.membership_renewal_info }}</p>
        <label for="agreement">
          <input type="checkbox" name="agreement" id="agreement" v-model="isAgree" class="agree-checkbox"> <span>I agree</span>
      </label>
      </div>
      <div class="btn" @click.stop="handlePay">Pay Now</div>
    </div>
  </div>
</template>
<script>
import { priceTransfer } from '@/utils';
import { cardValidate, pay } from '@/api';

export default {
  name: 'Payment',
  data() {
    return {
      visible: false,
      paymentList: [
        {
          icon: 'credit',
          name: 'Credit/Debit Card',
        },
      ],
      productInfo: {},
      activeIdx: 0,
      priceTransfer,
      cardNumber: '',
      date: '',
      cvv: '',
      firstName: '',
      lastName: '',
      email: '',
      effectivedayList: {
        1: 'day',
        7: 'week',
        30: 'month',
        180: '6 months',
        365: 'year',
      },
      payType: '',
      isAgree: true,
    };
  },
  watch: {
  },
  methods: {
    show(opts = {}) {
      this.productInfo = opts;
      this.payType = opts?.payType ?? '';
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.$destroy(true);
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
    },
    async handlePay() {
      if (this.payType === 'subscription' && !this.isAgree) {
        this.$toast('please agree before you pay...');
        return;
      }
      const loading = this.$loading();
      const validate = ['cardNumber', 'date', 'cvv', 'email', 'firstName', 'lastName'];
      const isEmpty = validate.some((item) => {
        if (!this[item]) {
          this.$toast.error(`${item} is empty`);
          return true;
        }
        return false;
      });
      if (isEmpty) {
        loading.close();
      } else {
        const { date = '' } = this;
        let expiredMonth = '';
        let expiredYear = '';
        if (date.includes('/')) {
          const expireList = date.split('/');
          expiredMonth = expireList[0] || '';
          expiredYear = expireList[1] || '';
        } else {
          expiredMonth = date.slice(0, 2);
          expiredYear = date.slice(2);
        }
        const {
          cardNumber = '', cvv = '', email = '', firstName = '', lastName = '',
        } = this;
        const card = {
          cardNumber, expiredMonth, expiredYear, cvv,
        };
        const billingAddress = { email, firstName, lastName };
        const validateRes = await cardValidate({
          card, billingAddress,
        });
        if (validateRes.code !== 0) {
          this.$toast.error('this card in invalid');
        } else {
          const payRes = await pay({
            product_id: this.productInfo?.id || '',
            card,
            billingAddress,
          });
          if (payRes.code === 0) {
            if (payRes?.data?.is_3ds && payRes?.data?.redirect_url) {
              window.location.href = payRes?.data?.redirect_url || '';
            } else {
              this.$toast.success('pay success');
            }
          } else {
            this.$toast.success(payRes?.message || 'payment error, try later');
          }
        }
        loading.close();
        this.handleClose();
      }
    },
    handleInput(e) {
      if (this.date.length > 1 && this.date.indexOf('/') === -1 && e.inputType === 'insertText') {
        this.date = this.date.slice(0, 2) + '/' + this.date.slice(2, 4);
      }
      if (this.date.length > 5) {
        this.date = this.date.slice(0, 5);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.payment {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  font-size: @fontSmall;
  overflow: auto;
  .payment-box {
    padding: 16px;
    background: #fff;
    margin-top: auto;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
  }
  .title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    i {
      content: '';
      width: 24px;
      height: 24px;
      background: url('@/assets/images/icon/close.png') center no-repeat;
      background-size: 100%;
      margin-left: auto;
    }
  }
  .recommend {
    background: linear-gradient(180deg, #30867D 0%, #0A694B 100%);
    color: #fff;
    padding: 8px;
    margin-bottom: 8px;
    border-radius: 12px;
    h3 {
      font-size: @fontLarge;
      font-weight: 700;
    }
    p {
      font-size: 16px;
      margin: 8px 0;
    }
    .payment-display {
      display: flex;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 8px 8px 16px 0;
        &.active {
          border: 1px solid black;
        }
        img {
          width: 36px;
          height: 24px;
          flex-shrink: 0;
        }
      }
    }
  }
  .info {
    padding: 12px;
    background: rgba(13, 13, 13, 0.06);
    border-radius: 12px;
    margin-bottom: 16px;
    color: @gray;
    p {
      line-height: 36px;
      display: flex;
      align-items: center;
    }
    .info-text {
      margin-left: auto;
      color: @black;
      &.price {
        font-weight: 700;
      }
    }
  }
  .fill {
    .content:empty:before{
      content: attr(placeholder);
      color:@gray;
    }
    .content:focus:before{
      content:none;
    }
    .card, .message, .address {
      display: flex;
      align-items: center;
      border-radius: 12px;
      margin-bottom: 8px;
    }
    .card {
      flex-direction: column;
      input {
        background: rgba(13, 13, 13, 0.06);
        padding: 0 12px;
        border-radius: 12px;
        height: 44px;
        line-height: 44px;
        width: 100%;
        margin-top: 8px;
        &:first-child {
          margin-top: 0;
        }
      }
    }
    .message {
      overflow: hidden;
      justify-content: space-between;
      input {
        background: rgba(13, 13, 13, 0.06);
        padding: 12px;
        border-radius: 12px;
        width: 160px;
        height: 44px;
        line-height: 44px;
        flex-shrink: 0;
      }
    }
    .address {
      overflow: hidden;
      justify-content: space-between;
      flex-wrap: wrap;
      input {
        background: rgba(13, 13, 13, 0.06);
        padding: 12px;
        border-radius: 12px;
        width: 160px;
        height: 44px;
        line-height: 44px;
        flex-shrink: 0;
        &.a-email {
          width: 100%;
          margin-top: 8px;
        }
      }
    }
  }
  .describe {
    padding: 12px;
    background: rgba(13, 13, 13, 0.06);
    border-radius: 12px;
    transform: scale(0.8);
    transform-origin: 0 0 0;
    width: 125%;
    color: #757575;
    label {
      margin-top: 5px;
      display: flex;
      align-items: center;
    }
    .agree-checkbox {
      width: 10px;
      height: 10px;
      border-radius: 3px;
      margin-right: 8px;
      background: #cac9c9;
      &:checked {
        background-color: #0a694b !important;
        position: relative;
        &::after {
          content: '';
          height: 3px;
          width: 5px;
          border: 1px solid #fff;
          position: absolute;
          top: 2px;
          left: 2.5px;
          border-top: none;
          border-right: none;
          transform: rotate(-45deg);
        }
      }
    }
  }
  .btn {
    margin: 12px 16px 0;
    padding: 10px;
    text-align: center;
    background: rgba(59, 220, 188, 1);
    border-radius: 99px;
    color: #fff;
    font-size: @fontMedium;
  }
}
</style>
